export default __webpack_public_path__ + "static/media/consultoria.b3d23f56.svg";